function e(r) {
  if (typeof r == "number")
    return r;
  if (typeof r != "string")
    return;
  const t = Number(r);
  return isNaN(t) ? void 0 : t;
}
export {
  e as p
};
